import {platformAPI} from "../../../api/axiosConfig";
import {AudioFile} from "../typedefs";
import {useQuery} from "react-query";

async function fetchAudioFile(id: string | undefined) {
    if (!id) return null;
    const res = await platformAPI.get<AudioFile>(`api/siren/audio-files/${id}`);
    return res.data;
}

export function useGetAudioFile(id: string | undefined) {
    const {data, isLoading, error, refetch} = useQuery(
        ["audio-file", id],
        () => fetchAudioFile(id),
        {enabled: !!id, cacheTime: 0, refetchOnMount: true}
    );
    return {data, isLoading, error, refetch};
}
